import {
  Button, Card, CardContent,
  CardHeader,
  CircularProgress,
  colors,
  Container,
  Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider,
  Grid
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import React, { useState } from 'react';
import Chart from 'react-chartjs-2';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getDifferenceInDays, getUser } from 'src/utils/Common';
import logger from 'src/utils/logger';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 5,
    minHeight: 580,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  container: {
    maxHeight: 440,
  },
}));

function SLA() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [ResponseData, setResponseData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [baslangicTarihi] = useState(moment().subtract(30, 'days').format("YYYY-MM-DD"));
  const [bitisTarihi] = useState(moment().format("YYYY-MM-DD"));







  const SessionUser = getUser();
  const handleClose = () => {
    setOpen(false);
  };


  const handleSearch = () => {
    if (getDifferenceInDays(new Date(baslangicTarihi), new Date(bitisTarihi)) > 30) {
      setUyari("İki tarih aralığı 30 günden büyük olamaz!...");
      setOpen(true);
      return
    }
    setLoading(true);
    axios.get('/GetArtemisSlaRapor/' + SessionUser.ServiceShopId + '/' + SessionUser.OrganizationUserId + '/' + baslangicTarihi + '/' + bitisTarihi)
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setResponseData([]);
        } else {
          setResponseData(Data);
        }
        setLoading(false);
      }).catch(error => {
        setResponseData([]);
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
  }
  var labelsSP = [];
  var dataSP = [];
  ResponseData.forEach(item => {
    labelsSP.push(item.SLA_DURUM);
    dataSP.push(item.ADET);
  });



  var highest = Math.max.apply(this, dataSP);
  var optionsbar = {
    indexAxis: 'y',
    responsive: true,
    scales: {
      y: {
        min: 0,
        max: highest,
        ticks: {
          stepSize: 10
        }
      }
    },
    plugins: {
      legend: {
        position: 'left',
        display: false,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle'
        }
      },
      title: {
        display: true,
        text: 'SLA Durumu',
        fontSize: 20
      },
    },
   
  }


  var data = {
    labels: labelsSP.slice(0, 12),
    // labels: ['Red', 'Blue', 'Purple', 'Yellow','green']
    datasets: [
      {
        type: 'pie',
        data: dataSP,
        label: '# Adet',
        backgroundColor: [colors.green[300],colors.yellow[300], colors.orange[300], colors.red[300], colors.red[900]],
        minBarLength: 1,
        borderWidth: 1,
      }
    ],
  };


  return (
    <Page className={classes.root} title="SLA">
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardHeader title="SLA" />
          <Divider />
          <CardContent>
            {loading && <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />}
            <br />
            <Grid container spacing={1}>
              
              <Grid item xs={12} sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitMaterialImage}
                  onClick={() => handleSearch()}
                  endIcon={<SearchIcon />}>
                  Sorgula
                </Button>
              </Grid>
            </Grid>
            <br />
            <Divider />
            <br />
          </CardContent>

        </Card>
        <br />
        <Card>
          {ResponseData.length > 0 ?
            <Chart type={'pie'} options={optionsbar} data={data} height={300} />
            : ""}
        </Card>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default SLA;
